// import React from 'react';
import ServiceView from 'view/op/ServiceView';

// const HomeOpNav = () =>
// {
//   return (
//     <>
//       <h1>首頁</h1>
//       <div>No preference for the home page display items</div>
//     </>
//   );
// }

export default ServiceView;